import { createSignal } from "solid-js";
import c from "class-c";

import Expand from "@repo/ui/animation/Expand";
import ContainerButton from "@repo/ui/buttons/ContainerButton";
import ListTile from "@repo/ui/info/ListTile";

import styles from "./CommunityGuidelines.module.scss";

const guidelines = [
  {
    title: "Be Kind & Respectful",
    description:
      "Keep the conversation positive and respectful. Everyone's here to learn. Disagreements are fine, but kindness is key.",
  },
  {
    title: "No Hate Speech or Bullying",
    description:
      "We welcome questions and discussions, but negativity, harassment, or hate speech towards others or Kikoff won't be tolerated.",
  },
  {
    title: "No Promotions or Spam",
    description:
      "This is a space for learning, not selling. Please avoid promoting other brands or services.",
  },
  {
    title: "Respect Privacy",
    description:
      "For your safety, do not share sensitive personal details that belong to you or anyone else.",
  },
];

function CommunityGuidelines() {
  return (
    <div class={styles["community-guidelines"]}>
      <header class="text:regular+">Kikoff Community Guidelines</header>
      <div class="text:small my-1">
        Welcome to the Kikoff Community!
        <br />
        <br />
        This is a space to share knowledge, ask questions, and support each
        other on the journey to better credit and financial wellness.
        <br />
        <br />
        <span class="text:small+">
          Kikoff moderators reserve the right to remove posts or users from the
          community if these guidelines are not followed.
        </span>
      </div>
      {guidelines.map((item, index) => (
        <CommunityGuidelinesItem item={item} index={index} />
      ))}
    </div>
  );
}

declare namespace CommunityGuidelinesItem {
  type Props = {
    item: (typeof guidelines)[number];
    index: number;
  };
}

function CommunityGuidelinesItem({
  item,
  index,
}: CommunityGuidelinesItem.Props) {
  const [show, setShow] = createSignal(false);

  return (
    <>
      <ContainerButton onClick={() => setShow(!show())}>
        <ListTile
          class="color:moderate my-0 py-1"
          propsFor={{
            leading: { class: styles["number"] },
            title: { class: styles["text"] },
          }}
          leading={index + 1}
          title={item.title}
          trailing={
            <span
              class={c`icon:small ${styles["caret"]} ${show() && styles["open"]}`}
            >
              
            </span>
          }
        />
      </ContainerButton>
      <Expand direction="y" show={show()}>
        <div class="text:small ml-3 mb-1">{item.description}</div>
      </Expand>
    </>
  );
}

export default CommunityGuidelines;
